// modifer: styles/jss/nextjs-material-kit-pro/pages/ecommerceSections/latestOffersStyle
import { section, container } from 'styles/jss/original/base';

const styles = {
  section: {
    ...section,
    '@media (max-width: 640px)': {
      marginTop: '0'
    }
  },
  container,
  textCenter: {
    textAlign: 'center'
  }
};

export default styles;
